import SectionTabs from '@/components/Home/HomepageV2/Tabs';
import { HOMEPAGE_TAB_SECTIONS, SECTION_TABS } from '@/shared/constants/homepage-constants';
import { map } from 'lodash-es';
import { HomepagePlatformSection } from '@/shared/types/homepage';
import TabSection from '@/components/Home/HomepageV2/TabSection';
import BrandGrid from '@/components/Home/HomepageV2/BrandGrid';
import SupplierProfileSection from '@/components/Home/HomepageV2/SupplierProfileSection';
import StartNow from '@/components/Home/HomepageV2/StartNow';
import React, { useRef } from 'react';
import HomePageIntro from '@/components/Home/HomepageV4/Intro';
import './index.less';
import FAQContainer from '@/components/Common/FAQContainer';
import { SEO_HOMEPAGE } from '@/shared/constants/seo';
import Script from 'next/script';
import { faqJsonLd } from '@/shared/seo/jsonld';

const HomepageV4 = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <div className="pietra-home-page-v3">
      <HomePageIntro />
      <div className="pietra-home-page-v3-content">
        <div className="text-section-wrap">
          <div className="text-section-content">
            <div className="title">AI that knows your business and does the work.</div>
            <div className="description">
              Your AI connects to your data and automates work typically done by agencies and consultants. Monitor
              competitors, create content, source products, and identify opportunities, all powered by AI trained on
              your specific business.
            </div>
          </div>
        </div>
        <SectionTabs tabs={SECTION_TABS} />
        <div className="homepage-tab-sections">
          {map(HOMEPAGE_TAB_SECTIONS, (section: HomepagePlatformSection) => {
            return <TabSection key={section.id} section={section} />;
          })}
        </div>
        <div ref={ref} className="homepage-bottom-content">
          <BrandGrid />
          <SupplierProfileSection />
          <FAQContainer faq={SEO_HOMEPAGE} />
          <Script
            id="faq-seo-homepage"
            type="application/ld+json"
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(faqJsonLd(SEO_HOMEPAGE)),
            }}
          />
          <StartNow />
        </div>
      </div>
    </div>
  );
};

export default HomepageV4;
